import { useRef, useEffect } from 'react';

const useResizeObserver = (callback, ref) => {
    const callbackRef = useRef(callback);
    const memoizedCallback = callbackRef.current;
    if (typeof window === 'undefined') {
        return;
    }
    if (!('ResizeObserver' in window)) {
        // if browser does not support resize observer return empty object
        return memoizedCallback({}, null);
    }
    const observer = useRef(null);
    useEffect(() => {
        const item = ref?.current;
        const unobserve = () => {
            observer?.current?.disconnect();
        };
        if (observer?.current) {
            unobserve();
        }
        if (item) {
            observer.current = new ResizeObserver(([entry], currentObserver) => {
                memoizedCallback(entry, currentObserver);
            });
            observer.current.observe(item);
        }
        return () => unobserve();
    }, [ref]);
};

export { useResizeObserver };
//# sourceMappingURL=useResizeObserver.js.map
